import { flowRight } from 'lodash';

import { RouteItemType } from '~/core/router';
import {
  withCheckoutOpeningLayout,
  withHomeScreenRetentionLayout,
  withMainLayout,
  withOnboardingLayout,
  withSubModalsLayout,
} from '~/decorators/withLayout';
import lazyComponentLoader from '~/helpers/lazyComponentLoader';

import { BlackFridayPath, BlackFridayProductId } from './constants';

const BlackFriday = lazyComponentLoader(
  () => import('./views/BlackFridayPage'),
);

const BlackFridayRoute: RouteItemType = {
  Component: flowRight(
    withCheckoutOpeningLayout,
    withSubModalsLayout,
    withOnboardingLayout,
    withHomeScreenRetentionLayout,
    withMainLayout,
  )(BlackFriday),
  path: BlackFridayPath,
  getTitle: (t) => t('black_friday:title', 'Black Friday'),
  checkAvailability: (profile) => {
    return (
      profile.user_product.id !== BlackFridayProductId &&
      !profile.is_stripe_user
    );
  },
};

export { BlackFriday, BlackFridayRoute };
